"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentStateDropdown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const STATE_DROPDOWN_LIST = [
    { id: 'select', title: 'assignment.assignmentStatus' },
    { id: 'closed', title: 'assignment.closed' },
    { id: 'open', title: 'assignment.open' },
    { id: 'created', title: 'assignment.created' },
];
const VISIBILITY_DROPDOWN_LIST = [
    { id: 'select', title: 'assignment.isPublic' },
    { id: 'created', title: 'assignment.visible' },
    { id: 'hide', title: 'assignment.hide' },
];
exports.AssignmentStateDropdown = react_1.default.memo(({ status, setStatus, isBackOffice = false }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [value, setValue] = react_1.default.useState({
        id: 'select',
        title: 'assignment.assignmentStatus',
    });
    react_1.default.useEffect(() => {
        const list = isBackOffice ? VISIBILITY_DROPDOWN_LIST : STATE_DROPDOWN_LIST;
        if (status !== value.id)
            setValue(list.find(item => item.id === status));
    }, [status, isBackOffice]);
    const handlerUpdateDrop = (item) => {
        setStatus(item.id);
        setValue(item);
    };
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", value: value, list: isBackOffice ? VISIBILITY_DROPDOWN_LIST : STATE_DROPDOWN_LIST, styles: {
            ...(isMobile ? {} : { dropWrap: { width: isTablet ? 120 : 150 } }),
            itemWrap: {
                top: isTablet ? '50px' : '45px',
            },
        }, setDropValue: handlerUpdateDrop }));
});
